module.exports = __webpack_public_path__ + "static/img/offer1.c65f47e.d0f54b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/offer1.c65f47e.png
// module id = 631
// module chunks = 4